<script setup lang="ts">
    const props = defineProps({
        class: {
            type: String,
            required: false
        },
        type: {
            type: String as () => 'menu' | 'voucher',
            default: 'menu',
        },
    })

    const classObject = reactive({
        'flex border-b-[.1rem] border-b-[lightGray]' : props.type == 'menu',
        'flex gap-[1.6rem] pb-[.8rem] ' : props.type == 'voucher'
    })
</script>

<template>
    <dl :class="[
        classObject,
        props.class
    ]">
        <slot />
    </dl>
</template>